<template lang="pug">
.flex.flex-col.items-center(v-if="twin?.uuid")
  img(v-if="qrCode !== null", :src="qrCode", @click="printCode")
  el-button(:icon="Printer", circle, @click="printCode")
</template>

<script setup lang="ts">
import QRCode from "qrcode";
import { computed, onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import type { TwinResponse } from "@shared/services/twinManagement";
import { Printer } from "@element-plus/icons-vue";

const props = defineProps<{
  twin?: TwinResponse;
}>();

// QRCode
const qrCode = ref(null);

onMounted(calculateQrCode);

const route = useRoute();

async function calculateQrCode() {
  if (props.twin?.uuid) {
    qrCode.value = await QRCode.toDataURL(
      `${window.location.protocol}//${window.location.host}/twin-redirect/${props.twin?.uuid}`,
    );
  }
}

watch(() => props.twin, calculateQrCode);

const printable = ref(null);

const internalNumber = computed(() => {
  return props.twin?.properties?.find(
    (item) => item.customId === "internalNumber",
  )?.propertyValue?.value as string;
});

function printCode() {
  const url = encodeURI(
    `/print-twin/${props.twin!.uuid}/${props.twin!.name}/${internalNumber.value ? internalNumber.value : props.twin?.uuid}`,
  );
  const win = window.open(
    url,
    "",
    ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"].join(","),
  );

  setTimeout(() => {
    win.document.close();
    win.focus();
    win.print();
    win.close();
  }, 1000);
}
</script>
